import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\BermudaDS\\Legacy\\CODE\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\BermudaDS\\Legacy\\CODE\\src\\app\\faq\\components\\FAQContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\BermudaDS\\Legacy\\CODE\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\BermudaDS\\Legacy\\CODE\\src\\components\\ui\\AppImage.tsx");
